{
  "fr": {
    "published": {
      "labels": {
        "notPublished": "Non publié",
        "publishedCustomer": "Publié pour les clients",
        "publishedCustomerPartners": "Publié pour les clients et les partenaires",
        "publishedPartners": "Publié pour les partenaires"
      },
      "publish_mode": {
        "inherit": "Suivre le modèle",
        "inherit_info": "Conserver l'état publié ou non publié de chaque élément du modèle"
      }
    }
  }
}
